import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useCourseSubjectsUIContext } from "../CourseSubjectsUIContext";

const prepareFilter = (queryParams, values) => {
  const { subject, code, explanation } = values;
  const courseId = queryParams.filter.courseId;
  const newQueryParams = { ...queryParams };
  const filter = { courseId, subject, code, explanation };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function CourseSubjectsFilter() {
  // Course Subjects UI Context
  const courseSubjectsUIContext = useCourseSubjectsUIContext();
  const courseSubjectsUIProps = useMemo(() => {
    return {
      setQueryParams: courseSubjectsUIContext.setQueryParams,
      queryParams: courseSubjectsUIContext.queryParams,
    };
  }, [courseSubjectsUIContext]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(courseSubjectsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, courseSubjectsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      courseSubjectsUIProps.setQueryParams(newQueryParams);
    }
  };
  
  return (
    <Formik
      initialValues={{
        subject: "",
        code: "",
        explanation: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="subject"
                placeholder="Konu"
                onBlur={handleBlur}
                value={values.subject}
                onChange={(e) => {
                  setFieldValue("subject", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Konu</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="code"
                placeholder="Kodu"
                onBlur={handleBlur}
                value={values.code}
                onChange={(e) => {
                  setFieldValue("code", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kodu</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="explanation"
                placeholder="Açıklaması"
                onBlur={handleBlur}
                value={values.explanation}
                onChange={(e) => {
                  setFieldValue("explanation", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Açıklaması</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}